export default "__VITE_ASSET__SKdoVyyu__"